import React from 'react';

const CategoryModal = ({ 
  isOpen, 
  onClose, 
  categoryEdit, 
  categoryNameInput, 
  setCategoryNameInput,
  categoryColorInput,
  setCategoryColorInput,
  onSave 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="bg-white rounded-xl p-6 w-full max-w-xs relative">
        <button onClick={onClose} className="absolute top-2 right-2 text-xl font-bold">×</button>
        <h3 className="text-lg font-bold mb-4">{categoryEdit ? 'Edit' : 'Add'} Category</h3>
        <input 
          className="w-full border rounded px-2 py-1 mb-2" 
          placeholder="Category name" 
          value={categoryNameInput} 
          onChange={e => setCategoryNameInput(e.target.value)} 
        />
        <input 
          className="w-full border rounded px-2 py-1 mb-4" 
          type="color" 
          value={categoryColorInput} 
          onChange={e => setCategoryColorInput(e.target.value)} 
        />
        <div className="flex gap-2">
          <button 
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded shadow hover:bg-gray-400 font-semibold transition duration-200 flex-1" 
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="bg-primary text-white px-4 py-2 rounded shadow hover:bg-secondary hover:text-primary font-semibold transition duration-200 flex-1" 
            onClick={onSave}
          >
            {categoryEdit ? 'Save' : 'Add'} Category
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryModal;
